import { Injectable } from '@angular/core';
import { BaseCadouhApiService } from '../../../shared/services/base-cadouh-api.service';
import { Observable } from 'rxjs';
import { VendorStaff } from '../models/VendorStaff';
import { CreateStaffPayload, UpdateStaffPayload } from '../models/staff-payload';

@Injectable({
  providedIn: 'root'
})
export class UsersManagementApiService extends BaseCadouhApiService {

  getVendorStaff(): Observable<VendorStaff[]> {
    return this.http.get<any>(`${this.baseUrl}/giftshop/admin/vendor_staff/`, {
      headers: this.getRequestHeadersWithToken(),
    });
  }

  getVendorStaffById(id:string): Observable<VendorStaff> {
    return this.http.get<any>(`${this.baseUrl}/giftshop/admin/vendor_staff/${id}`, {
      headers: this.getRequestHeadersWithToken(),
    });
  }

  createVendorStaff(payload: CreateStaffPayload): Observable<VendorStaff> {
    return this.http.post<VendorStaff>(
      `${this.baseUrl}/giftshop/admin/vendor_staff/`,
      payload,
      { headers: this.getRequestHeadersWithToken() }
    );
  }

  updateVendorStaff(id: string | number, payload: UpdateStaffPayload): Observable<VendorStaff> {
    return this.http.put<VendorStaff>(
      `${this.baseUrl}/giftshop/admin/vendor_staff/${id}/`,
      payload,
      { headers: this.getRequestHeadersWithToken() }
    );
  }

  setVendorStaffActive(id: string | number, isActive: boolean): Observable<VendorStaff> {
    return this.http.patch<VendorStaff>(
      `${this.baseUrl}/giftshop/admin/vendor_staff/${id}/`,
      { is_active: isActive },
      { headers: this.getRequestHeadersWithToken() }
    );
  }
}
